import { render, staticRenderFns } from "./ClientActivateDialog.vue?vue&type=template&id=2b59823f&"
import script from "./ClientActivateDialog.vue?vue&type=script&lang=js&"
export * from "./ClientActivateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientActivateDialog.vue"
export default component.exports